import AuthContactPanel from 'components/common/AuthContactPanel';
import React from 'react';

const EventLandingRightPanel = () => {
  return (
    <>
      <AuthContactPanel />
    </>
  );
};

export default EventLandingRightPanel;
